import { Link } from "react-router-dom";

const NAV = [
  { id: "about", label: "About", href: "/#about" },
  { id: "products", label: "Products", href: "/products", internal: true },
  { id: "classina", label: "Classina®", href: "/classina", internal: true },
  { id: "capabilities", label: "Capabilities", href: "/#capabilities" },
  { id: "why", label: "Why SBK", href: "/#why" },
  { id: "contact", label: "Contact", href: "/#contact" },
];

const Footer = () => (
  <footer data-testid="site-footer" className="bg-stone-50 border-t border-stone-200">
    <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
      <div>
        <Link to="/" className="flex items-center">
          <img
            src="/sbk-logo.png"
            alt="SBK Manufacturing Company"
            className="h-16 md:h-20 w-auto select-none"
            draggable="false"
          />
        </Link>
        <p className="mt-6 text-stone-700 leading-relaxed max-w-sm">
          Crafting world-class notebooks for students, professionals and creatives — exported globally since 2014.
        </p>
      </div>
      <div>
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone-700 mb-5">
          Explore
        </div>
        <ul className="space-y-3">
          {NAV.map((n) =>
            n.internal ? (
              <li key={n.id}>
                <Link
                  to={n.href}
                  className="text-ink-900 hover:text-terracotta-600 transition-colors"
                >
                  {n.label}
                </Link>
              </li>
            ) : (
              <li key={n.id}>
                <a
                  href={n.href}
                  className="text-ink-900 hover:text-terracotta-600 transition-colors"
                >
                  {n.label}
                </a>
              </li>
            )
          )}
        </ul>
      </div>
      <div>
        <div className="font-mono text-[10px] tracking-[0.25em] uppercase text-stone-700 mb-5">
          Reach Us
        </div>
        <p className="text-ink-900">230/4 Nana Peth, Pragati Villa</p>
        <p className="text-ink-900">Pune 411002, India</p>
        <p className="mt-3 text-ink-900">+91 99607 49074</p>
        <a
          href="mailto:info@sbkmanufacturing.com"
          className="text-terracotta-600 hover:underline"
        >
          info@sbkmanufacturing.com
        </a>
      </div>
    </div>
    <div className="border-t border-stone-200 py-6">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 font-mono text-[11px] tracking-[0.2em] uppercase text-stone-700">
        <span>© {new Date().getFullYear()} SBK Manufacturing Company</span>
        <span>Crafted with care · Pune, India</span>
      </div>
    </div>
  </footer>
);

export default Footer;
